exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ir-warning-box{background:#ffd;color:#220;padding:2px;border:1px solid #f0c020;margin:15px 0}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/components/Modules/WarninigBox/WarningBox.less
 ** module id = 1069
 ** module chunks = 0
 **/